import {BasketItemTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/tracker.types';
import {ItemTrackingData} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/item_tracking_data.types';
import {
  TrackingBasketItem,
  TrackingBasketItemWithoutPrices,
} from '@aboutyou/legacy-tracking-sdk';
import {getTrackingPrice} from './getTrackingPrice';
import {getProduct} from './getTrackingProduct';
import {getTrackingSize} from './getTrackingVariant';
import {Brand} from './types';

export const getNewTrackingBasketItem = (
  itemTrackingData: ItemTrackingData,
  brand: Brand,
  sizeLabel: string,
): TrackingBasketItem => {
  return {
    product: getProduct({product: itemTrackingData.product, brand, badges: []}),
    key: itemTrackingData.key,
    variant: getTrackingSize(itemTrackingData.size, sizeLabel),
    selectedQuantity: itemTrackingData.quantity,
    totalPrice: getTrackingPrice(itemTrackingData.totalPrice),
    unitPrice: getTrackingPrice(itemTrackingData.unitPrice),
    additionalData: undefined,
  };
};

// eslint-disable-next-line complexity
export const convertProductToTrackingBasketItem = ({
  basketTracker,
}: {
  basketTracker: BasketItemTracker;
}): TrackingBasketItemWithoutPrices => {
  const priceObject = {
    withoutTax: basketTracker.minPrice?.priceWithoutTax || -1,
    withTax: basketTracker.minPrice?.price || -1,
    currency: basketTracker.minPrice?.currencyCode || '*** NOT AVAILABLE ***',
    saleReductionWithTax: basketTracker.minPrice?.saleReduction || 0,
    campaignReductionWithTax: basketTracker.minPrice?.campaignReduction || 0,
    fullPrice: basketTracker.minPrice?.fullPrice || 0,
    couponReductionWithTax: basketTracker.minPrice?.couponReduction || 0,
    coinsReductionWithTax: basketTracker.minPrice?.coinsReduction || 0,
  };

  const variantObject = {
    id: basketTracker.size.sizeId,
    supplierId: basketTracker.size.suppliedId,
    sizeLabel: basketTracker.size.sizeLabel,
    price: {
      withoutTax: basketTracker.unitPrice?.priceWithoutTax || -1,
      withTax: basketTracker.unitPrice?.price || -1,
      currency:
        basketTracker.unitPrice?.currencyCode || '*** NOT AVAILABLE ***',
      saleReductionWithTax: basketTracker.unitPrice?.saleReduction || 0,
      campaignReductionWithTax: basketTracker.unitPrice?.campaignReduction || 0,
      fullPrice: basketTracker.minPrice?.fullPrice || 0,
      couponReductionWithTax: basketTracker.minPrice?.couponReduction || 0,
      coinsReductionWithTax: basketTracker.minPrice?.coinsReduction || 0,
    },
  };

  return {
    key: basketTracker.key,
    product: {
      id: basketTracker.productId,
      name: basketTracker.name,
      brand: {
        id: basketTracker.brand.id || -1,
        name: basketTracker.brand.name || '*** NO BRAND FOUND ***',
      },
      isSoldOut: basketTracker.isSoldOut,
      url: basketTracker.url,
      masterKey: basketTracker.masterKey || '',
      isSponsored: basketTracker.isSponsored,
      colors: [],
      minPrice: priceObject,
      unitPrice: {
        withoutTax: basketTracker.unitPrice?.priceWithoutTax || -1,
        withTax: basketTracker.unitPrice?.price || -1,
        currency:
          basketTracker.unitPrice?.currencyCode || '*** NOT AVAILABLE ***',
        saleReductionWithTax: basketTracker.unitPrice?.saleReduction || 0,
        campaignReductionWithTax:
          basketTracker.unitPrice?.campaignReduction || 0,
        fullPrice: basketTracker.minPrice?.fullPrice || 0,
        couponReductionWithTax: basketTracker.minPrice?.couponReduction || 0,
        coinsReductionWithTax: basketTracker.minPrice?.coinsReduction || 0,
      },
      badges: [],
    },
    selectedQuantity: basketTracker.quantity,
    variant: variantObject,
  };
};
